import * as types from "./types";

const defaultState = {

    pollList: [],
    poll: [],
    pollTable: {

        tableHeaders: [
            "Title",
            "Description",
            "Status",
            "Start Date",
            "End Date",
            "Type",
            "Posted By",
            "Actions"
        ],
        tableColumns: [
            "pollTitle",
            "pollDescription",
            "pollStatus",
            "pollStartDate",
            "pollEndDate",
            "pollTypeId",
            "createdUserId"
        ]
    },
    pollForm: {
        model: "PollModel",
        form: [
            {
                type: 'text',
                label: 'Poll Title',
                name: 'pollTitle',
                placeholder: 'Enter poll title',
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: 'select',
                label: 'Poll Type',
                name: 'pollTypeId',
                required: true,
                default: '1',
                md: 12,
                xs: 12
            },
            {
                type: 'dateTimeRange',
                required: true,
                default: '',
                maxLength: 255,
                md: 12,
                xs: 12
            },
            {
                component: 'textarea',
                label: 'Poll Description',
                name: 'pollDescription',
                placeholder: 'Description Here...',
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            }
        ]
    },
    candidateForm: {
        model: 'CandidateModel',
        form: [
            {
                type: 'text',
                label: 'Name',
                name: 'choiceLabel',
                placeholder: 'Enter candidate name',
                default: '',
                required: true,
                maxLength: 125
            },
            {
                type: "editor",
                label: "Description",
                name: "choiceDescription",
                required: true,
                default: '',
                md: 12,
                xs: 12
            },
        ]
    },

    announcementForm: {
        model: 'AnnouncementModel',
        form: [
            {
                type: "editor",
                name: "pollAnnouncementResult",
                default: '',
                md: 6,
                xs: 12
            },
        ]
    },

    selectInput: [
        {
            name: 'pollTypeId',
            value: 1,
            label: 'Survey'
        },
        {
            name: 'pollTypeId',
            value: 2,
            label: 'Election'
        }
    ]

};

export default function reducer(state = defaultState, action) {
    switch (action.type) {

        case types.SET_LIST:
            return { ...state, pollList: action.payload };
        case types.SET_POLL:
            return { ...state, poll: action.payload }
        default: return state;
    }
}